<template>
  <div id="userconfirm">userconfirm</div>
</template>

<script>
import { part } from "@/utils/mixins";
import { mapActions } from "vuex";
export default {
  mixins: [part],
  name: "userconfirm",
};
</script>

<style>
</style>